import { Component, Input } from '@angular/core';

/**
 * Fortschrittsanzeige der Academy: dünner Balken (CI-Blau auf heller Spur)
 * und darunter „x von y“ plus Prozent. Für Gesamtstand, Themen und
 * Zertifikate — überall dieselbe Anzeige.
 */
@Component({
  selector: 'app-academy-progress',
  template: `
    <div
      class="bar"
      role="progressbar"
      [attr.aria-valuenow]="percent"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-label]="label || null"
    >
      <span class="fill" [style.width.%]="percent" [class.is-done]="percent >= 100"></span>
    </div>
    <div class="meta" *ngIf="!hideMeta">
      <span>{{ 'academy.progress.of' | translate: { done: done, total: total } }}</span>
      <span class="pct">{{ percent }} %</span>
    </div>
  `,
  styles: [
    `
      :host { display: block; min-width: 0; }
      .bar {
        position: relative;
        height: 6px;
        border-radius: 999px;
        background: rgb(37 53 81 / 0.1);
        overflow: hidden;
      }
      :host(.is-large) .bar { height: 10px; }
      .fill {
        position: absolute;
        inset: 0 auto 0 0;
        border-radius: inherit;
        background: var(--al-action);
        transition: width 400ms ease;
      }
      .fill.is-done { background: #00a35c; }
      .meta {
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
        margin-top: 0.375rem;
        font-size: 0.75rem;
        color: var(--al-text-muted);
        font-variant-numeric: tabular-nums;
      }
      @media (prefers-reduced-motion: reduce) { .fill { transition: none; } }
    `,
  ],
})
export class AcademyProgressComponent {
  @Input() done = 0;
  @Input() total = 0;
  @Input() label = '';
  @Input() hideMeta = false;

  get percent(): number {
    return this.total ? Math.min(100, Math.round((this.done / this.total) * 100)) : 0;
  }
}
